module.exports = __webpack_public_path__ + "img/Im4.d0635d66.png";